import { Button } from '@sunwebgroup/uds-ui/button'

import { Sheet } from '@sunwebgroup/uds-ui/sheet'
import * as React from 'react'

import { useIntl } from 'react-intl'
import { useCMSPageField } from '@/cms/fields'
import { RoomType } from './RoomType'
import styles from './ShowAllRoomTypes.module.css'

function ShowAllRoomTypes({ onOpenChange }: {
  onOpenChange: (isOpen: boolean) => void
}): React.ReactElement {
  const roomTypes = useCMSPageField('PDP.roomTypes')
  const intl = useIntl()

  return (
    <Sheet.Root onOpenChange={onOpenChange}>
      <Sheet.Trigger>
        <Button className={styles.trigger} variant="outlinedPrimary">{intl.formatMessage({ id: 'roomtypes_show_more_label' }, { amount_roomtypes: roomTypes.length })}</Button>
      </Sheet.Trigger>
      <Sheet.Body side="right">
        <Sheet.Header titleLabel={intl.formatMessage({ id: 'roomtypes_heading' })} closeLabel={intl.formatMessage({ id: 'close' })} />
        <Sheet.Content className={styles.sheetContent}>
          {roomTypes.map(roomType => (
            <RoomType roomType={roomType} key={roomType.id} />
          ))}
        </Sheet.Content>
      </Sheet.Body>
    </Sheet.Root>
  )
}

export default ShowAllRoomTypes
